import * as React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Typography,
  TypographyProps,
  Box,
} from '@mui/material';

/********************************************************************************
 * PORTABLE TEXT
 * ----------------------------------------------------------------------------
 * This component uses portable text to render the accordion content which
 * means that it can inherit anything that the portable text component can do.
 * *****************************************************************************/
import { BasicPortableText } from 'src/components';

interface AccordionProps {
  value: {
    defaultOpen: boolean;
    name: string;
    title: string;
    titleVariant: TypographyProps['variant'];
    content: any;
  };
}

const AccordionComponent = ({ value }: AccordionProps) => {
  if (!value) return null;

  return (
    
      <Accordion
        className="accordion-component"
        component={Box}        
        sx={{             
          width: '100%',
          boxShadow: 'none',
          border: '1px solid #D9D9D9',
          borderRadius: '5px',
          '&:before': {
            display: 'none',
          },
          '&:not(:first-of-type)': {
            // Reduces the margin top for all accordions except the first one
            mt: .1,  // Adjust this value as needed (e.g., 1, 0.5)
          },
          '&:not(:last-of-type)': {
            // Reduces the margin bottom for all accordions except the last one
            mb: 1,  // Adjust this value as needed (e.g., 1, 0.5)
          }
        }}
        defaultExpanded={value?.defaultOpen}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant={value?.titleVariant ?? 'body1'}>{value?.title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {value?.content && <BasicPortableText content={value?.content} />}
        </AccordionDetails>
      </Accordion>
    
  );
};

export default AccordionComponent;
